export const localizeValue = (value, locale) => {
    return typeof value === "undefined" ? "0" : Number(value).toLocaleString(locale);
};